export enum FaqStatuses {
  PUBLICATED = 'publicated',
  UNPUBLICATED = 'unpublicated',
  CATEGORY = 'categories',
}

export enum SearchKeysFaq {
  SEARCH_NAME = 'searchName',
  SEARCH_TITLE = 'searchTitle',
  SEARCH_CATEGORY = 'searchCategory',
  SEARCH_ID = 'byId',
}
